export default "__VITE_ASSET__CzXElkrO__"